import { createRouter, createWebHistory } from 'vue-router'
import { h } from 'vue'
import Dashboard from "./views/Dashboard";
import SimpleDashboard from "./views/SimpleDashboard.vue";
import Default from "@/components/layouts/Default";
import Blank from "@/components/layouts/Blank.vue";
import Login from "@/views/auth/Login.vue";
import Organization from "@/views/organization/Organization.vue";
import notify from "@/utils/notify";
import permissions from "@/utils/permissions";
import Users from "@/views/user/Users.vue";
import ForgotPassword from "@/views/auth/ForgotPassword.vue";
import UpdatePassword from "@/views/auth/UpdatePassword.vue";
import UserProfile from "@/views/user/UserProfile.vue";
import ChangePassword from "@/views/user/ChangePassword.vue";
import AllOrganizations from "@/views/organization/AllOrganizations.vue";
import VerifyOtp from "@/views/auth/VerifyOtp.vue";
import {decrypt} from "@/utils/crypto";
import SignUp from "@/views/auth/SignUp.vue";
import Stores from "@/views/store/Stores.vue";
import StoreDetails from "@/views/store/StoreDetails.vue";
import Products from "@/views/product/Products.vue";
import AddProduct from "@/views/product/AddProduct.vue";
import ProductDetails from "@/views/product/ProductDetails.vue";
import EditProduct from "@/views/product/EditProduct.vue";
import Categories from "@/views/category/Categories.vue";
import Brands from "@/views/brand/Brands.vue";
import Storefront from "@/views/storefront/Storefront.vue";
import Units from "@/views/unit/Units.vue";
import ProductsByCategory from "@/views/category/ProductsByCategory.vue";
import Suppliers from "@/views/supplier/Suppliers.vue";
import AddSupplier from "@/views/supplier/AddSupplier.vue";
import SupplierDetails from "@/views/supplier/SupplierDetails.vue";
import EditSupplier from "@/views/supplier/EditSupplier.vue";
import ProductsBySupplier from "@/views/supplier/ProductsBySupplier.vue";
import SelectStore from "@/views/store/SelectStore.vue";
import Transfers from "@/views/transfer/Transfers.vue";
import TransferDetails from "@/views/transfer/TransferDetails.vue";
import Stock from "@/views/store/Stock.vue";
import ProductHistory from "@/views/product/ProductHistory.vue";
import StockTakes from "@/views/stock-take/StockTakes.vue";
import StockTakeDetails from "@/views/stock-take/StockTakeDetails.vue";
import StoreOrders from "@/views/store-order/StoreOrders.vue";
import StoreOrderDetails from "@/views/store-order/StoreOrderDetails.vue";
import Orders from "@/views/order/Orders.vue";
import OrderDetails from "@/views/order/OrderDetails.vue";
import AllStoreOrders from "@/views/order/AllStoreOrders.vue";
import Pos from "@/views/pos/Pos.vue";
import Sales from "@/views/sale/Sales.vue";
import SaleDetails from "@/views/sale/SaleDetails.vue";
import StoreSales from "@/views/sale/StoreSales.vue";
import AnnualAnalytics from "@/views/analytics/AnnualAnalytics.vue";
import Logs from "@/views/account/Logs.vue";
import Purchases from "@/views/purchase/Purchases.vue";
import PurchaseDetails from "@/views/purchase/PurchaseDetails.vue";
import Transactions from "@/views/transaction/Transactions.vue";
import SSOAuth from "@/views/auth/SSOAuth.vue";
import DailyAnalytics from "@/views/analytics/DailyAnalytics.vue";
import GeneralAnalytics from "@/views/analytics/GeneralAnalytics.vue";
import StockTakeAnalytics from "@/views/analytics/StockTakeAnalytics.vue";
import ProductSalesWithStock from "@/views/analytics/ProductSalesWithStock.vue";
import Settings from "@/views/account/Settings.vue";
import DirectPurchases from "@/views/purchase/DirectPurchases.vue";
import DirectPurchaseDetails from "@/views/purchase/DirectPurchaseDetails.vue";
import Returns from "@/views/return/Returns.vue";
import ReturnDetails from "@/views/return/ReturnDetails.vue";
import Customers from "@/views/customer/Customers.vue";
import AddCustomer from "@/views/customer/AddCustomer.vue";
import CustomerDetails from "@/views/customer/CustomerDetails.vue";
import EditCustomer from "@/views/customer/EditCustomer.vue";
import Invoices from "@/views/invoice/Invoices.vue";
import InvoiceDetails from "@/views/invoice/InvoiceDetails.vue";
import Quotations from "@/views/quotation/Quotations.vue";
import QuotationDetails from "@/views/quotation/QuotationDetails.vue";
import MpesaIntegrations from "@/views/mpesa/MpesaIntegrations.vue";
import StoreTransfers from "@/views/store-transfer/StoreTransfers.vue";
import StoreTransferDetails from "@/views/store-transfer/StoreTransferDetails.vue";
import SupplierReturns from "@/views/supplier-return/SupplierReturns.vue";
import SupplierReturnDetails from "@/views/supplier-return/SupplierReturnDetails.vue";
import SupplierPayments from "@/views/supplier/SupplierPayments.vue";
import Shifts from "@/views/shift/Shifts.vue";
import ShiftDetails from "@/views/shift/ShiftDetails.vue";
import ZReports from "@/views/zreport/ZReports.vue";
import ZReportDetails from "@/views/zreport/ZReportDetails.vue";
import MonthlyProductSales from "@/views/analytics/MonthlyProductSales.vue";
import TopSellingCategories from "@/views/analytics/TopSellingCategories.vue";
import LowStockProducts from "@/views/analytics/LowStockProducts.vue";
import SalesTrends from "@/views/analytics/SalesTrends.vue";
import RevenueByPaymentMethod from "@/views/analytics/RevenueByPaymentMethod.vue";
import ProductPerformance from "@/views/analytics/ProductPerformance.vue";

const router = createRouter({
    history: createWebHistory(),
    routes:[
        { path: '/', redirect: '/dashboard' },
        {
            path: '/',
            component: Default,
            children: [
                {
                    path:'/dashboard',
                    component: {
                        render() {
                            const profile = JSON.parse(decrypt(sessionStorage.getItem('profile')))
                            const regularUserRoles = ['user', 'cashier', 'inventory']
                            if (regularUserRoles.includes(profile.role)) {
                                return h(SimpleDashboard)
                            }
                            return h(Dashboard)
                        }
                    },
                },
                {
                    path:'/organization',
                    component:Organization,
                },
                {
                    path:'/stores',
                    component:Stores,
                },
                {
                    path:'/store/:id',
                    component:StoreDetails,
                },
                {
                    path:'/products',
                    component:Products,
                },
                {
                    path:'/add-product',
                    component:AddProduct,
                },
                {
                    path:'/product/:id',
                    component:ProductDetails,
                },
                {
                    path:'/edit-product/:id',
                    component:EditProduct,
                },
                {
                    path:'/categories',
                    component:Categories,
                },
                {
                    path:'/brands',
                    component:Brands,
                },
                {
                    path:'/storefront',
                    component:Storefront,
                },
                {
                    path:'/category/:id/products',
                    component:ProductsByCategory,
                },
                {
                    path:'/units',
                    component:Units,
                },
                {
                    path:'/suppliers',
                    component:Suppliers,
                },
                {
                    path:'/add-supplier',
                    component:AddSupplier,
                },
                {
                    path:'/supplier/:id',
                    component:SupplierDetails,
                },
                {
                    path:'/edit-supplier/:id',
                    component:EditSupplier,
                },
                {
                    path:'/supplier/:id/products',
                    component:ProductsBySupplier,
                },
                {
                    path:'/sales',
                    component:Sales,
                },
                {
                    path:'/store-sales',
                    component:StoreSales,
                },
                {
                    path:'/sale/:id',
                    component:SaleDetails,
                },
                {
                    path:'/all-store-orders',
                    component:AllStoreOrders,
                },
                {
                    path:'/orders',
                    component:Orders,
                },
                {
                    path:'/purchases',
                    component:Purchases,
                },
                {
                    path:'/purchase/:id',
                    component:PurchaseDetails,
                },
                {
                    path:'/direct-purchases',
                    component:DirectPurchases
                },
                {
                    path:'/direct-purchase/:id',
                    component:DirectPurchaseDetails,
                },
                {
                    path:'/returns',
                    component:Returns,
                },
                {
                    path:'/returns/:id',
                    component:ReturnDetails,
                },
                {
                    path:'/transactions',
                    component:Transactions,
                },
                {
                    path:'/order/:id',
                    component:OrderDetails,
                },
                {
                    path:'/transfers',
                    component:Transfers,
                },
                {
                    path:'/transfer/:id',
                    component:TransferDetails,
                },
                {
                    path:'/store-products',
                    component:Stock,
                },
                {
                    path:'/product/:storeId/history/:productId',
                    name:'product-history',
                    component:ProductHistory,
                },
                {
                    path:'/stock-take',
                    component:StockTakes,
                },
                {
                    path:'/stock-take/:id',
                    component:StockTakeDetails,
                },
                {
                    path:'/store-orders',
                    component:StoreOrders,
                },
                {
                    path:'/store-order/:id',
                    component:StoreOrderDetails,
                },
                {
                    path:'/annual-report',
                    component:AnnualAnalytics,
                },
                {
                    path:'/daily-report',
                    component:DailyAnalytics
                },
                {
                    path:'/general-report',
                    component:GeneralAnalytics
                },
                {
                    path:'/stock-take-analytics',
                    component:StockTakeAnalytics
                },
                {
                    path:'/product-sales-with-stock',
                    component:ProductSalesWithStock
                },
                {
                    path:'/logs',
                    component:Logs,
                },
                {
                    path:'/settings',
                    component:Settings,
                },
                {
                    path:'/users',
                    component:Users,
                },
                {
                    path:'/profile',
                    component:UserProfile,
                },
                {
                    path:'/change-password',
                    component:ChangePassword,
                },
                {
                    path:'/organizations',
                    component:AllOrganizations,
                },
                {
                    path:'/customers',
                    component:Customers,
                },
                {
                    path:'/add-customer',
                    component:AddCustomer,
                },
                {
                    path:'/customer/:id',
                    component:CustomerDetails,
                },
                {
                    path:'/edit-customer/:id',
                    component:EditCustomer,
                },
                {
                    path:'/invoices',
                    component:Invoices,
                },
                {
                    path:'/invoice/:id',
                    component:InvoiceDetails,
                },
                {
                    path:'/quotations',
                    component:Quotations,
                },
                {
                    path:'/quotation/:id',
                    component:QuotationDetails,
                },
                {
                    path:'/mpesa-integrations',
                    component:MpesaIntegrations,
                },
                {
                    path:'/store-transfers',
                    component:StoreTransfers,
                },
                {
                    path:'/store-transfer/:id',
                    component:StoreTransferDetails,
                },
                {
                    path:'/supplier-returns',
                    component:SupplierReturns,
                },
                {
                    path:'/supplier-return/:id',
                    component:SupplierReturnDetails,
                },
                {
                    path:'/supplier-payments',
                    component:SupplierPayments,
                },
                {
                    path:'/shifts',
                    component:Shifts,
                },
                {
                    path:'/shift/:id',
                    component:ShiftDetails,
                },
                {
                    path:'/z-reports',
                    component:ZReports,
                },
                {
                    path:'/z-report/:id',
                    component:ZReportDetails,
                },
                {
                    path:'/monthly-product-sales',
                    component:MonthlyProductSales,
                },
                {
                    path:'/top-selling-categories',
                    component:TopSellingCategories,
                },
                {
                    path:'/low-stock-products',
                    component:LowStockProducts,
                },
                {
                    path:'/sales-trends',
                    component:SalesTrends,
                },
                {
                    path:'/revenue-by-payment-method',
                    component:RevenueByPaymentMethod,
                },
                {
                    path:'/product-performance',
                    component:ProductPerformance,
                },
            ]
        },
        {
            path: '/',
            component: Blank,
            children: [
                {
                    path:'/login',
                    component:Login,
                },
                {
                    path:'/auth',
                    component:SSOAuth,
                },
                {
                    path:'/signup',
                    component:SignUp,
                },
                {
                    path:'/verify-otp',
                    component:VerifyOtp
                },
                {
                    path:'/select-store',
                    component:SelectStore
                },
                {
                    path:'/pos',
                    component:Pos,
                },
                {
                    path:'/forgot-password',
                    component:ForgotPassword,
                },
                {
                    path:'/update-password/:email',
                    component:UpdatePassword,
                },
            ],
        },
    ],
});

// User access control
let unauthenticated = ["login", "logout", "auth", "signup", "verify-otp", "forgot-password", "update-password", "verifyPayslip"]
let superAdmin = ["organizations"]
let expiredSubscription = ["dashboard", "upgrade", "paymentSuccess", "select-store"]
let selectStore = ["select-store"]

let service = 'pos'
let accounts = process.env.VUE_APP_ACCOUNTS_URL + 'login'
let nextUrl = process.env.VUE_APP_BASE_URL + 'auth'

router.beforeEach(async (to, from, next) => {
    let routeTo = to.path.split('/', 2)[1]
    const token = sessionStorage.getItem('access_token')
    if (!unauthenticated.includes(routeTo)) {
        if (token) {
            let profile = JSON.parse(decrypt(sessionStorage.getItem('profile')))
            let store = sessionStorage.getItem('store')
            let subscription = decrypt(sessionStorage.getItem('subscriptionStatus'))
            let isSuperAdmin = profile.role === 'super-admin'
            
            if (profile.organization_id === null && routeTo !== 'create-organization') {
                notify.alert.info('Please create your organization first.')
                next('/create-organization')
                return
            }

            if (store === null && !selectStore.includes(routeTo)) {
                notify.alert.info('Please select a store to continue.')
                next('/select-store')
                return
            }
            
            if (subscription === '' && !expiredSubscription.includes(routeTo) || subscription === 'expired' && !expiredSubscription.includes(routeTo)) {
                notify.alert.warning('You have an expired subscription. Please renew your subscription.')
                next('/dashboard')
                return
            }
            
            if (superAdmin.includes(routeTo) && !isSuperAdmin) {
                notify.alert.warning('You do not have permission to access this page.')
                next('/dashboard')
                return
            }

            const hasPermission = await permissions.checkRoutePermission(to, profile)
            if (!hasPermission) {
                notify.alert.warning('You do not have permission to access this page.')
                next('/dashboard')
                return
            }
            
            next()
        } else {
            window.open(accounts + '?service=' + service +'&next=' + nextUrl, '_self')
        }
    } else {

        if (routeTo === 'logout') {
            window.open(accounts + '?service=' + service +'&next=' + 'logout', '_self')
        }

        if (routeTo === 'login') {
            window.open(accounts + '?service=' + service +'&next=' + nextUrl, '_self')
        }

        if (token) {
            notify.alert.info('You have an active session. Please logout first.')
            next()
        }
        next()
    }
})

export default router;
